import { ccv2Fetch } from './index';

/** @returns {Promise<{ queues: Array }>} */
export const fetchQueues = () => ccv2Fetch('/v2/callcenter/queues');

/** @param {string} queueKey @returns {Promise<Object>} */
export const fetchQueue = (queueKey) => ccv2Fetch(`/v2/callcenter/queues/${encodeURIComponent(queueKey)}`);

/** @param {Object} dto @returns {Promise<Object>} */
export const createQueue = (dto) =>
  ccv2Fetch('/v2/callcenter/queues', { method: 'POST', body: JSON.stringify(dto) });

/** @param {string} queueKey @param {Object} dto @returns {Promise<Object>} */
export const updateQueue = (queueKey, dto) =>
  ccv2Fetch(`/v2/callcenter/queues/${encodeURIComponent(queueKey)}`, {
    method: 'PUT',
    body: JSON.stringify(dto),
  });

/** @param {string} queueKey @returns {Promise<null>} */
export const deleteQueue = (queueKey) =>
  ccv2Fetch(`/v2/callcenter/queues/${encodeURIComponent(queueKey)}`, { method: 'DELETE' });

/** @param {string} queueKey @returns {Promise<Object>} */
export const fetchQueueMembers = (queueKey) =>
  ccv2Fetch(`/v2/callcenter/queues/${encodeURIComponent(queueKey)}/members`);
